import setupErrors from './setup-errors'

/*

 See usages of this component for more examples, here are few common ones

 ###############################################################################
 Common Scenario: apply error handling to an XHR request
 ###############################################################################

 $.post(url, {
   error: xhr => errorHandler(xhr)
 })

 model.fetch({
	error: (model, resp, options) => errorHandler(resp)
 )}


 ###############################################################################
 FormView error handling
 ###############################################################################

 ### No custom error handler ###
 -------------------------------
 error: xhr => errorHandler(xhr, {formView: this.formView})


 ### Old Way with custom error handling
 --------------------------------------

 error: (model, response, options) => {
	if (response.status == HttpStatusCodes.BAD_REQUEST) {
		var code = _.get(response, 'responseJSON.messageCode')
		if (code == 'datasets.trees.keys.duplicate') {
			var arg = highlight(response.responseJSON.arguments[0])
			this.formView.errorHtml(i18n.get(code, arg))
			return
		}
	}
	this.formView.error(response)
 })

 ### New Way with custom error handling
 --------------------------------------
 Important: you must return true if error handling should stop

 error: (model, response, options) => {
	errorHandler(response, {
		formView: this.formView,
		handler: (response) => {
			if (response.status == HttpStatusCodes.BAD_REQUEST) {
				var code = _.get(response, 'responseJSON.messageCode')
				if (code == 'datasets.trees.keys.duplicate') {
					var arg = highlight(response.responseJSON.arguments[0])
					this.formView.errorHtml(i18n.get(code, arg))
					return true
				}
			}
		})
	}
 }

 */


/**
 *
 * Use this function to assign an error handler to a XHR request.
 *
 * If only the xhr is provided the default error handling behavior will be used
 * and the error will be presented in a dialog.
 *
 * See the options below to change the behavior for your use case.
 *
 * @param {Xhr} xhr
 *
 * @param {Function} [options.handler]
 *  A function that will be invoked with the XHR response object.
 * 	If this function returns a truthy value then the default error handling will be skipped.
 * 	However, the standard error checks (offline, unauthorized, forbidden, not found)
 * 	will always be applied, regardless of this function being provided or not.
 * 	The handler will only be invoked once the standard checks all pass.
 *
 * @param {FormView} [options.formView]
 * 	Pass a formView instance to display the error on the form
 *
 * @param {Boolean} [options.display=false]
 * 	Pass true to show the error in the display pane
 *
 * @param {Boolean} [options.showEmptyState=true]
 * 	Passed through to display-error-handler.js
 * 	For authorized errors that do not mandate an empty state, this can optionally be set false.
 *
 */
function errorHandler(xhr, options = {}) {
	if (options.formView) {
		options.formView.error(xhr, options)
	} else {
		setupErrors.errorHandler(xhr, options)
	}
}

export default errorHandler
errorHandler.__filename__ = 'components/error-handler.js'
